module.exports = __webpack_public_path__ + "img/category-donation-bg-ocean.cb611aa.webp";